import React, {memo} from 'react';
import PaymentMethodItem from "./PaymentMethodItem";
import {Grid, Typography} from "@mui/material";
import PropTypes from "prop-types";
import {determinePaymentImage} from "../../util/PaymentUtils";
import {styled} from "@mui/material/styles";

const PaymentMethodsListContainer = styled(Grid)(({theme}) => ({
  display: 'flex',
  border: `0.07rem solid ${theme.palette.grey[200]}`,
  borderRadius: '0.57rem',
}));

const PaymentMethodsList = memo(
  function PaymentMethodsList({paymentMethods = [], onMenuAction, verifyPaymentMethod}) {
    return (
      <PaymentMethodsListContainer container direction={'column'}>
        {
          paymentMethods.length > 0 ? paymentMethods.map((paymentMethod) => {
            return <PaymentMethodItem
              key={paymentMethod.id}
              paymentMethod={paymentMethod}
              img={determinePaymentImage(paymentMethod)}
              cardTitle={`...${paymentMethod.lastFour}`}
              onMenuAction={onMenuAction}
              verifyPaymentMethod={verifyPaymentMethod}
              disableRemove={paymentMethods.length < 2}
            />
          }) : <Typography variant={'h5'} component={'strong'}>No payment method added yet</Typography>
        }
      </PaymentMethodsListContainer>
    );
  });

PaymentMethodsList.propTypes = {
  paymentMethods: PropTypes.array.isRequired,
};

export default PaymentMethodsList;
